// A failed request must never reach the console whole (PANEL-1628): an axios error, and the response
// the interceptor rejects with, carry the request config — the Authorization header and the request
// body — and often the response body as well. Sentry keeps console lines as breadcrumbs, so a logged
// error object is also a report. Only bounded diagnostic fields are kept: the HTTP status, an error
// code, or else the error kind. A local exception (a throw inside a .then handler, which the same
// catch receives) also keeps its message, cut to 200 characters: that is what makes the line useful,
// and app code does not put request data in messages. The one known exception is a SyntaxError:
// JSON.parse quotes the start of its input, which can be a response body, so its message is dropped.
const CODE = /^E[A-Z0-9_]{1,40}$/;
const NAME = /^[A-Za-z]{1,40}$/;
const MAX_MESSAGE = 200;

const isRequestFailure = (error) =>
  error.isAxiosError === true || 'config' in error || 'response' in error || 'request' in error;

export const requestFailureDetails = (error) => {
  const status = error && (error.response || error).status;
  const details = {};
  if (Number.isInteger(status) && status >= 100 && status <= 599) details.status = status;
  if (error && typeof error.code === 'string' && CODE.test(error.code)) details.code = error.code;
  if (Object.keys(details).length) return details;
  const local = error instanceof Error && !isRequestFailure(error);
  details.name = local && NAME.test(error.name) ? error.name : 'Error';
  if (local && !(error instanceof SyntaxError) && typeof error.message === 'string') {
    details.message = error.message.slice(0, MAX_MESSAGE);
  }
  return details;
};

// `level` names the console method, so it is always called on console (no detached method).
export const logRequestFailure = (message, error, level = 'error') => {
  console[level](message, requestFailureDetails(error));
};
